module.exports = __webpack_public_path__ + "static/undraw_3-d_modeling_h-60-h-bff928ee27a80ddd7cb2c84963bb80e6.svg";